import { TFunction } from "i18next";
import { toast } from "react-toastify";
import { toastResponseError } from "../../../utils/responseMessageHelper";

const MAX_SHOWN_ERRORS = 3;

export const toastImportAddressesErrors = (error: unknown, t: TFunction) => {
  const rowErrors = (error as { data?: { errors?: unknown } })?.data?.errors;

  if (Array.isArray(rowErrors) && rowErrors.length > MAX_SHOWN_ERRORS) {
    const message = [
      ...rowErrors.slice(0, MAX_SHOWN_ERRORS),
      t("books.importAddressesMoreErrors", {
        amount: rowErrors.length - MAX_SHOWN_ERRORS,
      }),
    ].join("; ");
    toast.error(message, { icon: false, autoClose: 8000 });
    return;
  }

  toastResponseError(error);
};
